import { put, select } from 'redux-saga/effects';
import { get } from 'lodash';

import { debug } from '../utils/logger';
import localStorage from '../utils/cacheUtils';
import { setBackToCatalogData } from '../actions/backToCatalogActions';
import { BACK_TO_CATALOG_DATA_KEY, BACK_TO_CATALOG_DATA_TTL } from '../constants';

export function* backToCatalogSaga() {
    debug('Saga: backToCatalogSaga initialized');
    let state = yield select();
    const backToCatalogDataFromLocalStorage = localStorage.get(BACK_TO_CATALOG_DATA_KEY);
    const userIsOnPdp = !!get(state, 'product.id');
    const userIsOnSearchPage = get(state, 'category.isSearch');
    const catalogRequestUrl = get(state, 'category.catalogRequestUrl');
    const searchTerm = get(state, 'category.searchTerm');

    if(userIsOnPdp) {
        if(backToCatalogDataFromLocalStorage) {
            yield put(setBackToCatalogData(backToCatalogDataFromLocalStorage));
        }
    } else if (userIsOnSearchPage && catalogRequestUrl && searchTerm) {
        const backToCatalogData = {
            'backToCatalogUrl' : catalogRequestUrl,
            'pageName': searchTerm
        };

        localStorage.set(BACK_TO_CATALOG_DATA_KEY, backToCatalogData, BACK_TO_CATALOG_DATA_TTL);
    } else {
        localStorage.remove(BACK_TO_CATALOG_DATA_KEY);
    }
}
